module.exports = __webpack_public_path__ + "images/Close bill_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Close bill_hover.png
// module id = 383
// module chunks = 0 1